import { Container, Vector2 } from '@cgs/wge';
import { T_ISlotGameEngineProvider } from '../../../type_definitions';
import { IReelsEngineProvider } from '../../game_components_providers/i_reels_engine_provider';
import { ISlotGameEngineProvider } from '../../game_components_providers/i_slot_game_engine_provider';
import { ReelsEngineGameConfig, SpinConfig } from '../../game_config/game_config';
import { ReelsEngine } from '../../reels_engine';
import { CollapsingSpinConfig } from './collapsing_spin_config';

export class CollapseGameConfig extends ReelsEngineGameConfig {
  public regularSpinCollapsingConfig: CollapsingSpinConfig;
  public freeSpinCollapsingConfig: CollapsingSpinConfig;

  constructor(container: Container, configDto: Record<string, any>, displayResolution: Vector2) {
    super(container, configDto, displayResolution);

    this.initCollapsingConfigs(container, configDto, displayResolution);
  }

  private initCollapsingConfigs(
    container: Container,
    configDto: Record<string, any>,
    displayResolution: Vector2
  ): void {
    if (configDto) {
      if (configDto['regularSpin']) {
        this.regularSpinConfig = new FreeFallSpinConfig(
          container,
          configDto['regularSpin'],
          Math.round(displayResolution.y)
        );
        this.regularSpinCollapsingConfig = new CollapsingSpinConfig(configDto['regularSpin']);
      }
      if (configDto['freeSpin']) {
        this.freeSpinConfig = new FreeFallSpinConfig(
          container,
          configDto['freeSpin'],
          Math.round(displayResolution.y)
        );
        this.freeSpinCollapsingConfig = new CollapsingSpinConfig(configDto['freeSpin']);
      }
    }
  }
}

export class FreeFallSpinConfig extends SpinConfig {
  get Engine(): ReelsEngine {
    if (!this._engine) {
      this._engine = (
        this._container.resolve<ISlotGameEngineProvider>(
          T_ISlotGameEngineProvider
        ) as IReelsEngineProvider
      ).reelsEngine;
    }
    return this._engine;
  }

  constructor(container: Container, configDto: Record<string, any>, displayHeight: number) {
    super(container, configDto, displayHeight);
    this._container = container;
  }

  public get spinSpeed(): number {
    return this.collapseSpinSpeed * this.speedMultiplier;
  }

  public get singleEntitySpinSpeed(): number {
    const speed = this.collapseSpinSpeed * this.speedMultiplier;
    const singleMaxSpeed = this.collapseSpinSpeed;
    return speed > singleMaxSpeed ? singleMaxSpeed : speed;
  }
}
